// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { signInExistingAccountStyles } from "@tps/Overrides/Widgets/SignIn/SignInExistingAccount";
import { xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

signInExistingAccountStyles.icon = {
    css: css`
        padding-top: 50px;
        &&& {
            background: transparent;
        }
    `,
};

signInExistingAccountStyles.signInExistingAccountTitle = {
    variant: "h2",
    css: css`
        margin-bottom: 18px;
    `,
};

signInExistingAccountStyles.userNameGridItem = {
    width: 12,
};

signInExistingAccountStyles.passwordGridItem = {
    width: 12,
    css: css`
        position: relative;
    `,
};

signInExistingAccountStyles.signInButtonGridItem = {
    width: 12,
    css: css`
        justify-content: flex-start;
    `,
};

signInExistingAccountStyles.rememberMeGridItem = {
    width: 6,
    css: css`
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
    `,
};

signInExistingAccountStyles.forgotPasswordGridItem = {
    width: 6,
    css: css`
        justify-content: flex-end;
        align-items: flex-end;
    `,
};

signInExistingAccountStyles.forgotPasswordLink = {
    typographyProps: {
        size: 12,
        weight: "bold",
        lineHeight: "17px",
        css: css`
            ${TypographyStyle} {
                letter-spacing: 0;
                line-height: 17px;
            }
        `,
    },
};

signInExistingAccountStyles.signInButton = {
    css: css`
        min-width: 149px;
        margin-top: 4px;
        ${xScreen("lte", 767)} {
            margin-top: 0;
        }
    `,
};

signInExistingAccountStyles.resetPasswordModal = {
    sizeVariant: "small",
};

signInExistingAccountStyles.changePasswordModal = {
    sizeVariant: "small",
};

signInExistingAccountStyles.signInGridContainer = {
    gap: 0,
    offsetCss: css`
        row-gap: 16px;
    `,
};
